// extracted by mini-css-extract-plugin
export default {"root":"PromoCodeField_root__FDCY8"};